<!-- =========================================================================================
    File Name: Clients.vue
    Description: Displays the list of user's company clients
========================================================================================== -->

<template>
    <div class="clients">
        <!-- <column-layout> -->
        <div class="flex flex-wrap justify-between items-start mb-8">
            <h2 class="font-light text-lg my-3">ÉDITER LA LISTE DE VOS CLIENTS</h2>
            <div class="flex">
                <!-- <vs-button :to="{path: '/' }" type="gradient" icon-pack="feather" icon="icon-chevron-left" class="mr-2">
                  Retour
                </vs-button> -->
                <!-- <vs-button :to="{ name: 'Editer un client', params: { idclient: -1 }}" type="gradient" color="success" icon-pack="feather" icon="icon-plus">
                  Ajouter un client
                </vs-button> -->
            </div>
        </div>

        <vs-card class="px-4 text-left" v-if="clients && clients.length > 0">

            <vs-table search stripe max-items="10" pagination :data="clients">
                <template slot="header">
                    <h3 class="h5 uppercase">
                        Vos Clients
                    </h3>
                    <vs-button size="large" class="leading-none ml-6 px-4 py-3 text-sm" color="primary"
                               @click="clientModal()">Importer des clients
                    </vs-button>
                    <ClientModal :show-modal="showClientModal" @close-modal="setMessage"/>
                </template>
                <template slot="thead">
                    <vs-th style="width:20px">&nbsp;</vs-th>
                    <vs-th sort-key="name">Nom du client</vs-th>
                    <vs-th sort-key="address1">Adresse</vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="index" v-for="(file, index) in data">
                        <vs-td>
                            <feather-icon icon="UserIcon" svgClasses="h-6 w-6 stroke-current text-success"/>
                        </vs-td>

                        <vs-td :data="data[index].name">
                            {{ data[index].name }}
                        </vs-td>

                        <vs-td :data="data[index].address1">
                            {{
                                data[index].address1
                            }}{{
                                Boolean(data[index].address2) ? ' ' + data[index].address2 + ', ' : ', '
                            }}{{ data[index].code_postal }} {{ data[index].city }} - {{ data[index].country }}
                        </vs-td>

                        <vs-td :data="data[index].id" style="width: 180px">
                            <div class="flex justify-end">
                                <vs-button type="border" color="primary"
                                           :to="{ name: 'Editer un client', params: { id: data[index].id }}">Afficher
                                </vs-button>
                            </div>
                        </vs-td>

                    </vs-tr>
                </template>

            </vs-table>
        </vs-card>

        <empty-card v-else/>

        <!--  ASIDE -->
        <!-- <template slot="aside">

          <h2 class="font-light text-lg mt-20 mb-4">AIDE :</h2>
          <div class="text-sm md:pr-4">
            <p class="mb-8">Eodem tempore Serenianus ex duce, cuius ignavia populatam in Phoenice Celsen ante rettulimus, pulsatae maiestatis imperii reus iure postulatus ac lege, incertum qua potuit suffragatione absolvi, aperte convictus familiarem suum cum pileo, quo caput operiebat, incantato vetitis artibus ad templum misisse fatidicum, quaeritatum expresse an ei firmum portenderetur imperium, ut cupiebat, et cunctum.</p>
          </div>
        </template>

      </column-layout> -->
    </div>
</template>

<script>
// @ is an alias to /src
import ColumnLayout from '@/layouts/columns/ColumnLayout.vue'
import ClientModal from "../../components/client/ClientModal";

import {mapState, mapActions} from 'vuex'

export default {
    name: 'Clients',
    data () {
        return {
            showClientModal: false
        }
    },
    components: {
        ColumnLayout,
        ClientModal
    },
    computed: {
        ...mapState({
            clients: state => state.client.clients,
            clientLoading: state => state.client.clientsLoading
        }),
        total: {
            get() {
                return this.$store.state.client.total
            },
            set(val) {
                this.$store.state.client.total = val
            }
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name === 'Clients') {
            this.$vs.loading()
            this.getAllClients({
                page: 1,
                limit: 100000
            }).then(() => {
                next()
                this.$vs.loading.close()
            }).catch(() => {
                this.$vs.loading.close()
                next()
            })
        } else {
            next()
        }
    },
    created() {
        this.refreshList()
    },
    methods: {
        ...mapActions('client', ['getAllClients', 'deleteClient']),

        refreshList() {
            this.$vs.loading()
            this.getAllClients({
                page: 1,
                limit: 100000
            }).then(() => {
                this.$vs.loading.close()
            }).catch(() => {
                this.$vs.loading.close()
            })
        },

        deleteItem(idclient) {
            this.deleteClient(idclient).then(() => {
                this.refreshList()
            })
        },

        clientModal() {
            this.showClientModal = true
        },

        setMessage(payload) {
            this.showClientModal = payload.boolean
        }
    }
}
</script>
